import { render, staticRenderFns } from "./BoardAgile.vue?vue&type=template&id=187799fc&"
import script from "./BoardAgile.vue?vue&type=script&lang=js&"
export * from "./BoardAgile.vue?vue&type=script&lang=js&"
import style0 from "./BoardAgile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports